import { hasSupport as e, wrap as t, get as o, set as r, remove as s } from "@analytics/global-storage-utils";
var a = "sessionStorage",
    l = e.bind(null, a),
    m = t(a, "getItem", o),
    i = t(a, "setItem", r),
    g = t(a, "removeItem", s);
export { a as SESSION_STORAGE, m as getSessionItem, l as hasSessionStorage, g as removeSessionItem, i as setSessionItem };